import React from 'react';
import { siteData } from '../mock';

const Portfolio = () => (
  <section id="portfolio" className="relative overflow-hidden bg-gradient-to-b from-black to-[#0d0d0d] py-20 lg:py-32">
    <div className="grain-overlay opacity-20"></div>
    <div className="absolute right-0 top-1/4 h-80 w-80 rounded-full bg-pink-accent/10 blur-[120px]"></div>
    <div className="relative z-10 mx-auto max-w-7xl px-4 lg:px-8">
      <div className="mb-12 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.28em] text-pink-accent">Current work</p>
          <h2 className="section-heading text-left">SELECTED DIRECTIONS</h2>
        </div>
        <p className="max-w-2xl text-sm leading-7 text-white/65 md:text-base">A design study still needs content gravity. These cards are here to communicate attitude and structure, not final detail.</p>
      </div>
      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {siteData.portfolio.map((project) => (
          <article key={project.id} className="project-card rounded-[1.8rem] border border-white/10 bg-white/[0.03] p-6 backdrop-blur-sm">
            <div className="mb-5 flex items-center justify-between gap-3">
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-pink-accent">{project.category}</span>
              <span className="rounded-full border border-white/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.22em] text-white/60">{project.status}</span>
            </div>
            <h3 className="mb-3 text-2xl font-semibold leading-tight text-white">{project.title}</h3>
            <p className="mb-6 text-sm leading-7 text-white/65">{project.description}</p>
            <div className="flex flex-wrap gap-2">
              {project.tags.map((tag) => (
                <span key={tag} className="rounded-full border border-white/10 px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-white/52">{tag}</span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Portfolio;
